import { createFileRoute, useNavigate, useLocation } from '@tanstack/react-router';
import { useEffect } from 'react';
import { usePermissions } from '../hooks/usePermissions';
import { usePermissionDeniedStore } from '../stores/permissionDenied.store';

export const Route = createFileRoute('/w/$workspaceId/gamification')({
  component: GamificationDashboardPage,
});

function GamificationDashboardPage() {
  const { workspaceId } = Route.useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { hasPermission } = usePermissions();
  const showPermissionDenied = usePermissionDeniedStore((state) => state.show);
  const canRead = hasPermission('gamification.view');

  useEffect(() => {
    if (!location.pathname.startsWith('/w/')) return;
    if (!canRead) {
      showPermissionDenied('Ver gamificação');
      navigate({ to: '/w/$workspaceId/clients', params: { workspaceId } });
    }
  }, [location.pathname, canRead, showPermissionDenied, navigate, workspaceId]);

  if (!canRead) return null;

  // Página desativada: manter rota apenas para compatibilidade com links antigos.
  // Redireciona automaticamente para a Loja de Benefícios.
  useEffect(() => {
    navigate({ to: '/w/$workspaceId/shop', params: { workspaceId }, replace: true });
  }, [navigate, workspaceId]);

  return null;
}
